export default "__VITE_ASSET__DBb_f6mA__"